import messages from "messages";
import { Tab, Tabs } from "react-bootstrap";
// types
import type { PatientForPatientEditor } from "components/patient-editor/types";
// components
import ContactInfoEditor from "../contact-info-editor/ContactInfoEditor";
import PatientInfoEditor from "../patient-info-editor/PatientInfoEditor";
// utils
import getClasses from "utils/getClasses";
// styles
import { MINOR_INFO_TABS } from "components/patient-editor/constants/minorInfoTabs";
import { AmplitudePageName } from "utils/amplitude";
import styles from "./MinorInfoEditor.module.scss";

type Props = {
  values: Partial<PatientForPatientEditor>[];
  onChange: (arg: PatientForPatientEditor[]) => void;
  onBillingContactChange: (arg: string) => void;
  onGuardianTypeChange: (arg: string) => void;
  billingContact: string;
  billingType: string;
  setBillingType: (arg: string) => void;
  labelClass?: string;
  className?: string;
  type?: string;
  amplitudePageName: AmplitudePageName;
  amplitudeComponentName?: string;
  activeKey: string;
  setKey: (arg: any) => void;
};

/**
 * renders a stateless UI for minor info creation and edit
 */
const MinorInfoEditor = ({
  values,
  onChange,
  onBillingContactChange,
  onGuardianTypeChange,
  billingContact,
  billingType,
  setBillingType,
  labelClass,
  className,
  amplitudePageName,
  amplitudeComponentName,
  type,
  activeKey,
  setKey,
}: Props) => {
  return (
    <div className={getClasses(className, styles["minor-info-editor"])}>
      <Tabs
        activeKey={activeKey}
        id="minor-info-tabs-controller"
        onSelect={(k) => {
          setKey((s) => k || s);
        }}
        className={styles["minor-info-editor__tabs"]}
      >
        {Object.values(MINOR_INFO_TABS).map((el, i) => (
          <Tab
            key={el.id}
            eventKey={el.id}
            title={messages[el.titleStringId]}
            tabClassName={styles["minor-info-editor__tab"]}
          >
            {el.id === MINOR_INFO_TABS.patient.id && (
              <PatientInfoEditor
                className={className}
                labelClass={labelClass}
                label={messages.patientInformation}
                value={values[i]}
                onChange={(arg) =>
                  onChange([...values.slice(0, i), arg, ...values.slice(i + 1)])
                }
                disableSelectFromExisting={true}
                type={type}
                amplitudePageName={amplitudePageName}
                amplitudeComponentName={amplitudeComponentName}
              />
            )}
            {el.id === MINOR_INFO_TABS.contact.id && (
              <ContactInfoEditor
                className={className}
                labelClass={labelClass}
                label={messages.contact}
                value={values[i]}
                onChange={(arg) => {
                  const nextValues = !values.length ? [{}] : values;

                  onChange([
                    ...nextValues.slice(0, i),
                    arg,
                    ...nextValues.slice(i + 1),
                  ]);
                }}
                onBillingContactChange={onBillingContactChange}
                billingContact={billingContact}
                billingType={billingType}
                setBillingType={setBillingType}
                onGuardianTypeChange={onGuardianTypeChange}
                amplitudePageName={amplitudePageName}
                amplitudeComponentName={amplitudeComponentName}
              />
            )}
          </Tab>
        ))}
      </Tabs>
    </div>
  );
};

export default MinorInfoEditor;
